/**
 * report-layout.ts — Bố cục thuần của khối báo cáo Tổng quan (chat-order-report.tsx), có test: số nhãn trục biểu đồ theo bề ngang
 * màn hình, cỡ chữ số theo độ dài, bề rộng thanh nhãn.
 */

/** Số nhãn tối đa trên trục ngang biểu đồ: điện thoại (≈ 311px) chỉ chứa khoảng 5 nhãn "DD/MM", máy tính khoảng 10. */
export const MAX_AXIS_LABELS = { mobile: 5, desktop: 10 } as const

/** Bước ghi nhãn trục (cứ `bước` cột ghi một nhãn) để không quá `maxLabels` nhãn chồng nhau. */
export function chartLabelStep(points: number, mobile: boolean): number {
  const max = mobile ? MAX_AXIS_LABELS.mobile : MAX_AXIS_LABELS.desktop
  return Math.max(1, Math.ceil(points / max))
}

/** Kỳ ngắn (≤ 10 ngày) ghi thứ (CN, T2…) và vẽ cột đôi rộng; kỳ dài ghi ngày/tháng thưa. */
export const isWeekView = (points: number) => points <= 10

/**
 * Cỡ chữ của con số lớn trên thẻ chỉ số theo số ký tự. Thẻ điện thoại chỉ rộng ~165px (xếp 2 cột) nên hạ sớm hơn máy tính;
 * số tiền nguyên "2.496.000 ₫" (11 ký tự) vẫn phải nằm gọn một dòng.
 */
export function metricValueClass(valueLength: number): string {
  if (valueLength > 12) return 'text-base sm:text-lg'
  if (valueLength > 9) return 'text-lg sm:text-xl'
  return 'text-xl sm:text-2xl'
}

/** Bề rộng (%) thanh của một nhãn so với nhãn nhiều nhất; luôn ≥ 4% để thấy được. Không có dữ liệu → 0. */
export function tagBarPct(count: number, max: number): number {
  if (max <= 0 || count <= 0) return 0
  return Math.max(4, Math.min(100, (count / max) * 100))
}
